export enum FilterParams {
	FILTER_NAME = 'filterinput',
	SORT_NAME = 'sort',
	PAGE_SIZE_NAME = 'pageSize',
	PAGE_INDEX_NAME = 'pageIndex',
}
